import { sessionRecordingControl } from 'features/analytics/sessionRecordingControl'
import { useGeckoPermissions } from 'features/permissions'
import { useState } from 'react'
import { PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

/** Org (NAES) whose internal users may toggle their own session recording. */
const SESSION_RECORDING_TOGGLE_ORG_ID = 'naes-36ab16'

export type ConfigSettingsProps = {
  orgID: string | undefined
  siteID: string | undefined
}

export const useConfigSettingsState = ({
  orgID,
}: Pick<ConfigSettingsProps, 'orgID'>) => {
  const { hasPermissions } = useGeckoPermissions()
  const isGeckoUser = hasPermissions([PERMISSION_GECKO_INTERNAL_MEMBER])

  const [isOpen, setIsOpen] = useState(false)
  const [recordingOn, setRecordingOn] = useState(
    sessionRecordingControl.isEnabled()
  )

  const isSessionRecordingOrg = orgID === SESSION_RECORDING_TOGGLE_ORG_ID

  return {
    isOpen,
    isSessionRecordingOrg,
    recordingOn,
    setIsOpen,
    setRecordingOn,
    shouldRender: isGeckoUser,
  }
}

export type ConfigSettingsState = ReturnType<typeof useConfigSettingsState>
